import { render, staticRenderFns } from "./EventReservation.vue?vue&type=template&id=58b5346a&scoped=true&"
import script from "./EventReservation.vue?vue&type=script&lang=js&"
export * from "./EventReservation.vue?vue&type=script&lang=js&"
import style0 from "./EventReservation.vue?vue&type=style&index=0&id=58b5346a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5346a",
  null
  
)

export default component.exports